import React, { useEffect, useState } from "react";

/**
 * PC_APc_04 getSpotlightData gets imported from api.js file
 */
import { getAppreciationData } from "../service/api";
import { useNavigate } from 'react-router-dom';

import '../components/css/Dashboard-styles.css'




const EmployeeAppreciation = () => {

    const navigate = useNavigate()

        /**
 * PC_APc_02
 * The data state variable is created for storing the response data
 */


    const [data, setData] = useState([])

    /**
  * PC_Apc_03
  * Use Efffect method is called 
  */

    useEffect(() => {

        fetchApi()

    }, [])


        /**
 * PC_APc_04
 * The fetchApi function in the useEffects gets invoked which inturn call the getAppreciationData() function with respective parameters
 */

    const fetchApi = async () => {

        const resp = await getAppreciationData()

        if (resp?.data?.ResponseData.length) setData(resp.data.ResponseData)


    }

    

        /**
 * PC_APc_10
 * The response data gets stored in the data variable and mapped to respective divs
 */

    const appreciatiobBody = () => {

        return (

            (data.length > 0) ?

                data.map((datum, i) => {
                    return (

                        <div className={`carousel-item ${i == 0 ? `active` : null} dashboard-custom-announcements-height-tm position-relative`}>
                            <h5 className="tt-bold font-15 p-3">Appreciation</h5>
                            <div className="d-flex ps-3 pe-5 mt-2">
                                <div className="w-25">
                                    <img src="/Images/logo-person-user-person-icon.jpg" className="dashboard-appreciation-image-tm" />
                                </div>
                                <div className="w-75">
                                    <p className="ps-3 mb-0 regular-text dashboard-appreciation-msg medium-text appreciation-trunc">{datum.feedback}</p>
                                    <a className="appreciation-read-more ps-3 pt-0 regular-text"
                                        onClick={() => { navigate('/empappreciation', { state: { id: datum.id } }) }}>Read More</a>
                                    <div class="d-flex justify-content-between mt-3">
                                        <p class="ps-3 semibold-text font-11">{`${datum.feedto},${datum.domain}`}</p>
                                        <p class="ps-3 semibold-text font-11">{datum.feedby}</p>
                                    </div>
                                </div>
                            </div>
                        </div>
                    )
                }) : <>

                    <div className={`carousel-item active dashboard-custom-announcements-height-tm position-relative`}>
                        <h5 className="tt-bold font-15 p-3">Appreciation</h5>
                    </div>

                </>
        )
    }

    return (

        <div className="rounded-5 dashboard-container-background dashboard-team-card-size dashboard-appreciation-card-size">
            <div id="carouselAppreciation" className="carousel slide carousel-fade custom-carousel-fade" data-bs-ride="carousel">
                <div className="carousel-indicators custom-carousel-indicators appreciation-carousel-indicators">

                    {data.length > 1 ? data.map((datum, i) => {

                        return (

                            <button type="button" data-bs-target="#carouselAppreciation"
                                data-bs-slide-to={i} className={(i == 0) ? "active" : ""}
                                aria-current={(i == 0) ? "true" : ""}
                                aria-label={`Slide ${i + 1}`} />
                        )

                    }) : <></>}
                    {/* <button type="button" data-bs-target="#carouselAppreciation" data-bs-slide-to={0} className="active" aria-current="true" aria-label="Slide 1" />
                    <button type="button" data-bs-target="#carouselAppreciation" data-bs-slide-to={1} aria-label="Slide 2" />
                    <button type="button" data-bs-target="#carouselAppreciation" data-bs-slide-to={2} aria-label="Slide 3" /> */}
                </div>
                <div className="carousel-inner dashboard-custom-carousel-inner">
                    {appreciatiobBody()}

                </div>
            </div>
        </div>

    )
}

export default EmployeeAppreciation